import * as React from 'react'
import * as styles from './loading.dots.styl'
import cx from 'classnames'

export interface Props {
  className?: string
  loading: boolean
  loadingText?: React.ReactNode
  size?: React.Key
  speed?: 'fast' | 'slow' | 'normal'
}

const WithLoadingDots: React.FC<Props> = ({
  loading,
  loadingText = null,
  className,
  children,
  size,
  speed = 'normal'
}: React.PropsWithChildren<Props>) =>
  loading ? (
    <span className={className}>
      {loadingText || children}
      <span
        style={{
          fontSize: size
        }}
        className={cx(styles.loading, styles[speed])}
      />
    </span>
  ) : (
    <>{children}</>
  )

export default WithLoadingDots
